<template>
  <div>
    <a-icon v-if="submitting" class="spinner" type="loading" />
    <form :class="{ 'submitting': submitting }" @submit.prevent='handleUpdate'>
      <h1>{{ `Edit ${$v.user.firstName.$model || ''} ${$v.user.lastName.$model || ''}` }}</h1>
      <div class='form-row' :class="{ 'form-group--error': $v.user.firstName.$error }">
        <label for='firstName' class="form__label">First name</label>
        <input name='firstName' class="form__input" type='text' placeholder="Enter first name" v-model.trim.lazy="$v.user.firstName.$model" @keydown='clearError($v.user.firstName)' />
        <div class="error" v-if="!$v.user.firstName.required && $v.user.firstName.$error">Required</div>
      </div>

      <div class='form-row' :class="{ 'form-group--error': $v.user.lastName.$error }">
        <label for='lastName' class="form__label">Last name</label>
        <input name='lastName' class="form__input" type='text' placeholder="Enter last name" v-model.trim.lazy="$v.user.lastName.$model" @keydown='clearError($v.user.lastName)' />
        <div class="error" v-if="!$v.user.lastName.required && $v.user.lastName.$error">Required</div>
      </div>

      <div class='form-row' :class="{ 'form-group--error': $v.user.email.$error }">
        <label for='email' class="form__label">Email</label>
        <input name='email' class="form__input" type='text' placeholder="Enter email address" v-model.trim.lazy="$v.user.email.$model" :readonly="true" />
        <div class="error" v-if="!$v.user.email.required && $v.user.email.$error">Required</div>
        <div class="error" v-if="!$v.user.email.email && $v.user.email.$error">Email format</div>
      </div>

      <div class='form-row' :class="{ 'form-group--error': $v.user.password.$error }">
        <label for='password' class="form__label">Change password</label>
        <input name='password' class="form__input" type='text' placeholder="Enter new password (min. 8 chars)" v-model.trim.lazy="$v.user.password.$model" @keydown='clearError($v.user.password)' />
        <!-- <div class="error" v-if="!$v.user.password.minLength && $v.user.password.$error">Min. 8 chars</div> -->
      </div>

      <div class='form-row' :class="{ 'form-group--error': $v.user.confirmPassword.$error }">
        <label for='confirmPassword' class="form__label">Confirm password</label>
        <input name='confirmPassword' class="form__input" type='text' placeholder="Enter password again" v-model.trim.lazy="$v.user.confirmPassword.$model" @keydown='clearError($v.user.confirmPassword)' />
        <div class="error" v-if="!$v.user.confirmPassword.sameAsPassword && $v.user.confirmPassword.$error">Not a match</div>
      </div>

      <div class='form-row' :class="{ 'form-group--error': $v.user.subscription.$error }">
        <label>Subscription</label>
        <SubscriptionAutocomplete :onBlur="onBlur" v-model="$v.user.subscription.$model" />
        <div class="error" v-if="!$v.user.subscription.required && $v.user.subscription.$error">Required</div>
      </div>

      <div class="ant-modal-footer">
        <div class='flat-button' @click="closeEditForm">Cancel</div>
        <button class='raised-button' type="submit" :disabled='$v.user.$invalid || submitting'>Save User</button>
      </div>
    </form>
  </div>
</template>

<script>
  import SubscriptionAutocomplete from '@/components/subscriptions/SubscriptionAutocomplete'
  import { mapState, mapActions, mapMutations } from 'vuex'
  import { required, minLength, email, sameAs, requiredIf } from 'vuelidate/lib/validators'

  export default  {
    name: 'EditUserForm',
    components: {
      SubscriptionAutocomplete
    },
    validations: {
      user: {
        firstName: {
          required,
        },
        lastName: {
          required,
        },
        email: {
          required,
          minLength: minLength(6),
          email
        },
        password: {
          // isValid:(password) => {
          //   if (!password) return true;
          //   return password.length >= 8;
          // },
        },
        confirmPassword: {
          sameAsPassword: sameAs('password'),
        },
        subscription: {
          required
        }
      }
    },
    computed: {
      ...mapState('editUserForm', ['user', 'submitting']),
    },
    methods: {
      ...mapMutations('editUserForm', ['close']),
      ...mapMutations('newUserForm', { clearSubscriptions: 'close' }),
      ...mapActions('editUserForm', ['updateUser']),
      handleUpdate(event) {
        this.updateUser(this.user)
      },
      clearError(input) {
       input.$reset()
      },
      onBlur() {
        this.$v.user.subscription.$touch();
      },
      closeEditForm() {
        this.close()
        this.clearSubscriptions()
      }
    },
  }
</script>

<style scoped lang="stylus">
  @import '../styles/buttons'
  @import '../styles/forms'
</style>